import React from 'react';
import { useNavigate } from 'react-router-dom';
import BasicMemberPortal from './BasicMemberPortal';

const BasicMemberPortalWrapper = () => {
  const navigate = useNavigate();

  // Get application data from localStorage or URL params
  const getApplicationData = () => {
    const stored = localStorage.getItem('basicMemberApplication');
    if (stored) {
      return JSON.parse(stored);
    }
    
    // Check if there's original application data with email
    const originalApplication = localStorage.getItem('legacyPropertyApplication');
    if (originalApplication) {
      const appData = JSON.parse(originalApplication);
      if (appData.email && appData.membershipLevel === 'Basic') {
        return {
          applicationId: appData.applicationId || 'basic-member-' + Date.now(),
          membershipLevel: 'Basic',
          memberName: appData.memberName || `${appData.firstName} ${appData.lastName}`,
          email: appData.email
        };
      }
    }
    
    // Default data if none found - but without email for upgrade functionality
    return {
      applicationId: 'basic-member-' + Date.now(),
      membershipLevel: 'Basic',
      memberName: 'Basic Member',
      email: null // This will trigger the error message asking to complete application
    };
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <BasicMemberPortal 
      applicationData={getApplicationData()}
      onBack={handleBack}
    />
  );
};

export default BasicMemberPortalWrapper;